import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import Modal from "../../../components/Modal";
import PostList from "../../../components/Admin/Publication/PostList";
import AddEditPostForm from "../../../components/Admin/Publication/AddEditPostForm";
import { getCatWithoutNotesApi } from '../../../api/category';
import { getSubCategoriesApi } from '../../../api/subcategory';
import { getPostsApi, getPostsDetaApi } from "../../../api/post";
import { getTagsApi } from '../../../api/tag';
import { errorModal, warningModal } from '../../../components/Alerts/Alerts';
import AddEditSubCatForm from '.././../../components/Admin/SubCategory/AddEditSubCatForm';


function Publication(props) {
    const [ posts, setPosts ] = useState(null);
    const [ reloadPosts, setReloadPosts ] = useState(false);
    const [ postsBase, setPostsBase ] = useState(null);
    const [ reloadPostsBase, setReloadPostsBase ] = useState(false);
    const [ isVisibleModal, setIsVisibleModal ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState("");
    const [ modalContent, setModalContent ] = useState(null);
    const [ reloadCategories, setReloadCategories ] = useState([]);
    const [ categories, setCategories ] =  useState([]);
    const [ reloadSubCategories, setReloadSubCategories ] = useState([]);
    const [ subcategories, setSubCategories ] =  useState([]);
    const [ tags, setTags ] =  useState([]);
    const [ reloadTags, setReloadTags ] = useState([]);

    useEffect (() => {
        getPostsDetaApi()
            .then(response => {
                if (response?.code !== 200){
                    warningModal("Advertencia", response.message);
                }else{
                    setPosts(response.posts);
                }
            })
            .catch(err => {
                errorModal	("Error", "Error del Servidor.");
            });

            setReloadPosts(false);
    }, [reloadPosts]);

    useEffect (() => {
        getPostsApi()
            .then(response => {
                if (response?.code !== 200){
                    warningModal("Advertencia", response.message);
                }else{
                    setPostsBase(response.posts);
                }
            })
            .catch(err => {
                errorModal	("Error", "Error del Servidor.");
            });

            setReloadPostsBase(false);
    }, [reloadPostsBase]);

    useEffect(() => {
        getCatWithoutNotesApi().then(response => {
            setCategories(response.category);
        });

        setReloadCategories(false);
    }, [reloadCategories]);

    useEffect(() => {
        getSubCategoriesApi().then(response => {
            setSubCategories(response.subCategory);
        });

        setReloadSubCategories(false);
    }, [reloadSubCategories]);

    useEffect(() => {
        getTagsApi().then(response => {
            setTags(response.tag);
        });

        setReloadTags(false);
    }, [reloadTags]);

    const addPost = () => {
        setIsVisibleModal(true);
        setModalTitle("Crear nueva Publicación");
        setModalContent(
                <AddEditPostForm
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadPosts={setReloadPosts}
                    post={null}
                    postsBase={null}
                    tags={tags}
                    setReloadTags={setReloadTags}
                />
            );
    }

    const editPost = post => {
        setIsVisibleModal(true);
        setModalTitle("Editar Publicación");
        setModalContent(
                <AddEditPostForm
                    setIsVisibleModal={setIsVisibleModal}
                    post={post}
                    setReloadPosts={setReloadPosts}
                    postsBase={Array.isArray(postsBase) && postsBase.find(el => el._id === post._id)}
                    setReloadPostsBase={setReloadPostsBase}
                    categories={categories}
                    setReloadCategories={setReloadCategories}
                    subcategories={subcategories}
                    setReloadSubCategories={setReloadSubCategories}
                    tags={tags}
                    setReloadTags={setReloadTags}
                    newSubcategory={newSubcategory}
                />
            );
    }

    const newSubcategory = e => {
        setIsVisibleModal(true);
        setModalTitle("Nueva Subcategoría");
        setModalContent(
                <AddEditSubCatForm
                    setIsVisibleModal={setIsVisibleModal}
                    subCategories={null}
                    subCategoriesBase={null}
                    categories={categories}
                />
            );
    }

    if (!posts){
        return null;
    }

    return (
        <>
            <div>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-8">
                                        <h1 className="h3 mb-4 text-gray-800">Mantenedor Publicaciones</h1>
                                    </div>
                                    <div className="col-4 text-right">
                                        <Link to={"/admin/new_publication"} className="btn btn-success"  >
                                            Nueva Publicación
                                        </Link>
                                    </div>

                                </div>
                                <div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card shadow">
                                                <div className="card-body">
                                                    <PostList 
                                                        posts={posts} 
                                                        postsBase={postsBase}
                                                        setReloadPosts={setReloadPosts} 
                                                        editPost={editPost} 
                                                        addPost={addPost} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={modalTitle}
                isVisible={isVisibleModal}
                setIsVisible={setIsVisibleModal}
                setSize='xl'
            >
                {modalContent}
            </Modal>
        </>
        
    )
}

export default withRouter(Publication);